{
  "BULK_ACTION": {
    "CONVERSATIONS_SELECTED": "{conversationCount} converses seleccionades",
    "AGENT_SELECT_LABEL": "Seleccionar Agent",
    "ASSIGN_CONFIRMATION_LABEL": "Estas segur d'assignar {conversationCount} {conversationLabel} a",
    "UNASSIGN_CONFIRMATION_LABEL": "Estàs segur de desassignar {conversationCount} {conversationLabel}?",
    "GO_BACK_LABEL": "Torna",
    "ASSIGN_LABEL": "Assignar",
    "YES": "Si",
    "SEARCH_INPUT_PLACEHOLDER": "Cercar",
    "ASSIGN_AGENT_TOOLTIP": "Assigna un agent",
    "ASSIGN_TEAM_TOOLTIP": "Assigna un equip",
    "ASSIGN_SUCCESFUL": "Les converses s'han assignat correctament.",
    "ASSIGN_FAILED": "No s'han pogut assignar les converses. Torna-ho a provar.",
    "RESOLVE_SUCCESFUL": "Les converses s'han resolt correctament.",
    "RESOLVE_FAILED": "No s'han pogut resoldre les converses. Torna-ho a provar.",
    "ALL_CONVERSATIONS_SELECTED_ALERT": "Les converses visibles en aquesta pàgina només estan seleccionades.",
    "AGENT_LIST_LOADING": "S'estan carregant els agents",
    "UPDATE": {
      "CHANGE_STATUS": "Canvia l'estat",
      "SNOOZE_UNTIL": "Posposat",
      "UPDATE_SUCCESFUL": "L'estat de les converses s'ha actualitzat correctament.",
      "UPDATE_FAILED": "No s'han pogut actualitzar les converses. Torna-ho a provar."
    },
    "LABELS": {
      "ASSIGN_LABELS": "Assignar etiquetes",
      "NO_LABELS_FOUND": "No s'han trobat etiquetes per a",
      "ASSIGN_SELECTED_LABELS": "Assigna les etiquetes seleccionades",
      "ASSIGN_SUCCESFUL": "L'etiqueta s'ha assignat correctament.",
      "ASSIGN_FAILED": "No s'han pogut assignar les etiquetes. Torna-ho a provar."
    },
    "TEAMS": {
      "TEAM_SELECT_LABEL": "Selecciona equip",
      "NONE": "Ningú",
      "NO_TEAMS_AVAILABLE": "Encara no hi ha cap equip afegit a aquest compte.",
      "ASSIGN_SELECTED_TEAMS": "Assigna l'equip seleccionat.",
      "ASSIGN_SUCCESFUL": "Equips assignats correctament.",
      "ASSIGN_FAILED": "No s'han pogut assignar els equips. Torna-ho a provar."
    },
    "MERGE": {
      "TOOLTIP": "Fusiona converses",
      "TITLE": "Fusiona converses",
      "DESCRIPTION": "Selecciona una conversa de destinació. Totes les altres converses seleccionades s'hi fusionaran: els seus missatges es mouran a la de destinació i les converses d'origen se suprimiran.",
      "TARGET_LABEL": "Conversa de destinació (es mantindrà)",
      "SOURCES_LABEL": "Converses d'origen (se suprimiran)",
      "SELECT_TARGET": "Selecciona una conversa com a destinació de la fusió",
      "WARNING": "Avís: aquesta acció no es pot desfer. Els missatges de totes les converses d'origen es mouran a la conversa de destinació i les converses d'origen se suprimiran de manera permanent.",
      "SUBMIT": "Fusiona converses",
      "CANCEL": "Cancel·la",
      "SUCCESS_MESSAGE": "Les converses s'han fusionat correctament",
      "ERROR_MESSAGE": "No s'han pogut fusionar les converses. Torna-ho a provar.",
      "CONFIRM": {
        "TITLE": "Confirma la fusió",
        "DESCRIPTION": "Estàs segur que vols fusionar {sourceCount} converses a la #{targetId}? Aquesta acció no es pot desfer.",
        "YES": "Sí, fusiona",
        "CANCEL": "Cancel·la"
      }
    }
  }
}
